<template>
    <nav aria-label="breadcrumb" class="modern-breadcrumb mb-4">
        <ol class="breadcrumb">
            <li class="breadcrumb-item" v-for="(item, index) in items" :key="item.id"  @click.prevent="index === items.length - 1 && navigateTo(item)">
                <a href="#" class="breadcrumb-link" :class="{ 'fw-bold': item.isBold && index !== items.length - 1 }">
                    <i v-if="item.icon" :class="`bi bi-${item.icon} me-1`"></i>
                    {{ item.title }}
                </a>
                <span class="separator" v-if="index !== items.length - 1">&gt;</span>
            </li>
        </ol>
    </nav>
</template>
    
<script>
import 'bootstrap-icons/font/bootstrap-icons.css';

export default {
    name: 'BreadcrumbElement',
    emits: ['change-view'],
    props: {
        items: {
            type: Array,
            required: true
        },
        currentPage: {
            type: String,
            required: true
        }
    },
    methods: {
        navigateTo(item) {
            // Usiamo l'emit standard di Vue, seguendo lo stesso pattern di Sidebar
            this.$emit('change-view', item);
        }
    }
}
</script>

<style scoped>
.modern-breadcrumb {
    background-color: transparent;
    padding: 0.5rem 0;
}

.breadcrumb {
    display: flex;
    align-items: center;
    margin-bottom: 0;
    padding: 0;
}

.breadcrumb-item {
    display: flex;
    align-items: center;
    position: relative;
    font-size:  1.1rem;
    color: black;
}

.breadcrumb-link {
    color: black;
    text-decoration: none;
    padding: 0.25rem 0.5rem;
    border-radius: 0.25rem;
    font-weight: 500;
}

.breadcrumb-link:hover {
    color: #0d6efd;
    background-color: rgba(74, 108, 247, 0.05);
}

.separator {
    color: black;
    font-size: 0.75rem;
    margin: 0 0.25rem;
}

.breadcrumb-item:last-child .separator {
    display: none;
}

.breadcrumb-item + .breadcrumb-item::before {
    content: none; /* rimuove lo slash */
}

.breadcrumb-item.active {
    color: black;
}

.current-page {
    font-weight: normal;
    color: black;
    padding: 0.25rem 0.5rem;
    font-size: 1.1rem;
}
</style>